"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _set = _interopRequireDefault(require("./set"));

var treeObj = function treeObj(obj) {
  var flatResult = {};

  if (obj === undefined || obj === null) {
    return;
  } else if (Array.isArray(obj)) {
    return;
  } else if ((0, _typeof2["default"])(obj) === 'object') {
    Object.entries(obj).forEach(function (_ref) {
      var _ref2 = (0, _slicedToArray2["default"])(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];

      var tokens = key.split('.');
      var firstToken = tokens[0] ? tokens[0] : '';

      if (tokens.length > 1) {
        (0, _set["default"])(flatResult, tokens, value);
      } else if (tokens.length === 1) {
        flatResult[firstToken] = value;
      }
    });
  }

  return flatResult;
};

var _default = treeObj;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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